"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var DataQualityDetail_1 = require("../../../dataQuality/DataQualityDetail");
var LayoutComponents_1 = require("../../../style/LayoutComponents");
var StyleFunctions_1 = require("../../../style/StyleFunctions");
// styles from vizportalclient, src/app/spaces/Explorer/ExplorerStyles.ts
var IconHeader = LayoutComponents_1.divWithStyle('IconCell', {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace,
    paddingRight: widgets_1.TabStyles.Spacing.MediumSpace,
});
exports.DataQualityHeaderIconClass = StyleFunctions_1.cssClass('DataQualityHeaderIconClass', {
    alignContent: 'center',
    display: 'flex',
    justifyContent: 'center'
});
// TODO: make this generic to use props.
function IconHeaderFormatter() {
    return (React.createElement(IconHeader, null,
        React.createElement(DataQualityDetail_1.DataStatusHeaderIcon, { className: exports.DataQualityHeaderIconClass })));
}
exports.DataQualityIconHeaderFormatterFactory = React.createFactory(IconHeaderFormatter);
//# sourceMappingURL=DataQualityIconHeaderFormatFactory.js.map